import { useEffect, useRef, useState } from "react";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

export const Section1 = () => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [inView, setInView] = useState(false);
  const isMobile = useResponsiveMobile();
  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect(); // 한 번만 실행
        }
      },
      {
        //  PC / 모바일 공통: “60%”
        threshold: 0,
        rootMargin: "0px 0px -40% 0px",
      },
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);
  function useMountEnter(delayMs = 0) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      const t = window.setTimeout(() => setMounted(true), delayMs);
      return () => window.clearTimeout(t);
    }, [delayMs]);

    return mounted;
  }
  const whoEnter = useMountEnter(80);

  const enterBase = "transition-all duration-[1000ms] ease-out will-change-transform";
  const enterHidden = "opacity-0 translate-y-8";
  const enterShown = "opacity-100 translate-y-0";
  const [titleMounted, setTitleMounted] = useState(false);

  useEffect(() => {
    // PC에서 첫 렌더 직후 제목 애니메이션 트리거
    const id = requestAnimationFrame(() => setTitleMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);

  const showTitle = titleMounted; // 모바일은 inView, PC는 mount 즉시

  return (
    <section className="gap-[60px] md:gap-[160px] flex flex-col justify-center items-center relative">
      <div className="flex flex-col gap-6 justify-center items-center">
        <span
          className={[
            "font-normal text-[#0079FF] text-center text-[18px]",
            enterBase,
            whoEnter ? enterShown : enterHidden,
          ].join(" ")}
        >
          What is Poom?
        </span>

        {/* ✅ 제목: PC는 렌더링 직후 올라옴 / 모바일은 inView */}
        <div
          className={[
            "transition-all will-change-transform text-center",
            "duration-[1600ms]",
            "ease-[cubic-bezier(0.16,1,0.3,1)]",
            showTitle ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10",
          ].join(" ")}
        >
          {isMobile ? (
            <h1 className="font-bold text-[36px] text-center">
              분산된 <span className="text-[#0079FF]">결제·정산</span> <br />
              <span className="text-[#0079FF]"> 프로세스</span>를
              <br />
              <span className="text-[#0079FF]"> 하나로 연결</span>하는 <br /> 솔루션 기반{" "}
              <span className="text-[#0079FF]">통합 플랫폼</span>
            </h1>
          ) : (
            <h1 className="font-bold text-display text-center">
              분산된 결제·정산 프로세스를 <br /> <span className="text-[#0079FF]">하나로 연결</span>
              하는 솔루션 기반 <span className="text-[#0079FF]">통합 플랫폼</span>
            </h1>
          )}
        </div>

        <div
          ref={textRef}
          className={[
            "transition-all will-change-transform text-center",
            "duration-[1600ms]",
            "ease-[cubic-bezier(0.16,1,0.3,1)]",
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10",
          ].join(" ")}
        >
          <span className="text-center text-[18px] md:text-heading1 font-normal text-[#4D4F58]">
            {isMobile ? (
              <>
                다양한 판매 채널에서 발생하는 데이터를 <br />
                통합 관리하여 정산 오류는 막고, <br />
                고객사 맞춤형 프로세스로 운영 효율성과 <br />
                안정성을 높이는 전문 정산 솔루션입니다
              </>
            ) : (
              <>
                다양한 판매 채널에서 발생하는 데이터를 통합 관리하여 정산 오류는 막고, <br />
                고객사 맞춤형 프로세스로 운영 효율성과 안정성을 높이는 전문 정산 솔루션입니다
              </>
            )}
          </span>
        </div>
      </div>

      <img
        className="z-10"
        alt="eg1"
        width={700}
        src={
          isMobile
            ? "/assets/images/serviceIntro/eg1_mobile.png"
            : "/assets/images/serviceIntro/eg1.png"
        }
      />
      <img
        className="absolute bottom-0 z-0 hidden md:flex"
        src="/assets/images/serviceIntro/gradient.png"
        alt="gradient"
      />
    </section>
  );
};
